<template>
  <v-dialog v-model="dialog" persistent width="780px">
    <v-card>
      <v-card-title class="headline">
        <v-icon>remove_red_eye</v-icon> Parametros programación de vacación
        <v-spacer></v-spacer>
        <v-btn icon @click="close()"> 
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-form v-model="valid" ref="form" lazy-validation>
        <v-card-text class="pt-0">
          <v-container grid-list-md class="pt-0">
          <v-layout row wrap>
              <p class="titulo">Gestión :</p>
              <p class="texto">{{ this.form.gestion }} </p>       
            </v-layout>
            <v-layout row wrap>
              <p class="titulo">Fecha inicio:</p>
              <p class="texto">{{ $moment(form.fecha_inicio).format("DD/MM/YYYY") }} </p> 
              <v-spacer></v-spacer>

            </v-layout>
             <v-layout row wrap>
              <p class="titulo">Fecha finalización:</p>
              <p class="texto">{{ $moment(form.fecha_fin).format("DD/MM/YYYY") }} </p>
            </v-layout>
             <v-layout row wrap v-if="this.form.fecha_corte">
              <p class="titulo">Porcentage de programación:</p>
              <p class="texto">{{ this.form.porcentaje }} % </p>       
            </v-layout>
            <v-layout row wrap v-if="this.form.fecha_ampliacion">
              <p class="titulo">Fecha ampliación:</p>
              <p class="texto">{{ $moment(form.fecha_ampliacion).format("DD/MM/YYYY") }} </p>       
            </v-layout>
            <v-layout row wrap v-if="this.form.fecha_corte">
              <p class="titulo">Fecha corte:</p>
              <p class="texto">{{ $moment(form.fecha_corte).format("DD/MM/YYYY") }} </p>       
            </v-layout>
         

          </v-container>
        </v-card-text>
        <v-card-actions class="pr-4">
          <v-spacer></v-spacer>

          <v-btn @click.native="close()" color="primary">
            <v-icon>cancel</v-icon> ACEPTAR
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false
    };
  },
  mounted() {
    this.$bus.$on("openDialogVerParametro", item => {
      this.form = item;
      this.dialog = true;
    });
  },
  methods: {
    close() {
      (this.form = {}), (this.loading = false);
      this.valid = false;
      this.$bus.$emit("closeDialogVerParametro");
      this.dialog = false;
	  this.form={}
    },
    async save() {
   
    }
  }
};
</script>

<style>
.titulo {
   font-size:1.07em;
  color: rgb(24, 106, 121);
  font-weight: bold;
}
.texto {
 font-size:1.07em;
  color: rgb(24, 106, 121);
}
</style>



// WEBPACK FOOTER //
// src/components/admin/parametros_vacacion/dialogs/VerParametro.vue